import React from 'react';
import { Caption, CaptionStyleId, EmojiMap, VideoTheme } from '../../types';
import { AbsoluteFill, useCurrentFrame, useVideoConfig } from 'remotion';
import { fitText } from '@remotion/layout-utils';
import { Horimozi1 } from './Horimozi1';
import { calculateColumnGap } from '../../utils/helper';
import { Tracy } from './Tracy';
import { Ali } from './Ali';
import { Beast } from './Beast';

interface SubtitleContainerProps {
  caption: Caption;
  currentFrame: number;
  theme: VideoTheme;
  emojiMap: EmojiMap;
}

export const SubtitleContainer: React.FC<SubtitleContainerProps> = ({
  caption,
  theme,
  currentFrame,
  emojiMap,
}) => {
  const {
    captionStyle: {
      highlightColor1,
      highlightColor2,
      highlightColor3,
      captionStyleId,
      enableFitText,
    },
  } = theme;

  const { width, height } = useVideoConfig();

  const desiredFontSize = Math.round((width / 1920) * theme.fontStyle.fontSize);

  const fittedText = fitText({
    fontFamily: theme.fontStyle.fontFamily,
    text: caption.text,
    withinWidth: width * 0.8,
  });

  const fontSize = enableFitText ? Math.min(desiredFontSize, fittedText.fontSize) : desiredFontSize;

  const captionPosY = Math.round((theme.captionStyle.positionY / 100) * (height || 1080));

  const highlightColors = [highlightColor1, highlightColor2, highlightColor3];

  const gap = calculateColumnGap(width);

  const emojiCode = caption?.emoji?.codePointAt(0)?.toString(16) || '';

  const emojiAnimationData = emojiMap.get(emojiCode);

  return (
    <AbsoluteFill>
      {captionStyleId === CaptionStyleId.Horimozi1 && (
        <Horimozi1
          fontSize={fontSize}
          captionPosY={captionPosY}
          caption={caption}
          theme={theme}
          currentFrame={currentFrame}
          highlightColors={highlightColors}
          gap={gap}
          emojiAnimationData={emojiAnimationData}
        />
      )}

      {captionStyleId === CaptionStyleId.Tracy && (
        <Tracy
          fontSize={fontSize}
          captionPosY={captionPosY}
          caption={caption}
          theme={theme}
          currentFrame={currentFrame}
          highlightColors={highlightColors}
          gap={gap}
          emojiAnimationData={emojiAnimationData}
        />
      )}

      {captionStyleId === CaptionStyleId.Ali && (
        <Ali
          fontSize={fontSize}
          captionPosY={captionPosY}
          caption={caption}
          theme={theme}
          currentFrame={currentFrame}
          highlightColors={highlightColors}
          gap={gap}
          emojiAnimationData={emojiAnimationData}
        />
      )}

      {captionStyleId === CaptionStyleId.Beast && (
        <Beast
          fontSize={fontSize}
          captionPosY={captionPosY}
          caption={caption}
          theme={theme}
          currentFrame={currentFrame}
          highlightColors={highlightColors}
          gap={gap}
          emojiAnimationData={emojiAnimationData}
        />
      )}
    </AbsoluteFill>
  );
};
